import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '#web-components/components/Typography';

import styles from './Info.styles';

export type InfoProps = {
  caption: string,
  value: string,
  dataXPathConfig?: { caption?: string, text?: string },
};

const useStyles = makeStyles(styles, { name: 'Info' });

export default function Info({ caption, value, dataXPathConfig }: InfoProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography data-xpath={dataXPathConfig?.caption} variant="textTiny" className={classes.caption}>
        {caption}
      </Typography>
      <Typography data-xpath={dataXPathConfig?.text} variant="textRegular" className={classes.text}>
        {value}
      </Typography>
    </Box>
  );
}
